module.exports = __webpack_public_path__ + "img/shopGuide2-c.6ddf4242.jpg";